import { RouterState } from 'connected-react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { ContractWizardState } from 'redux/reducers/contractWizard/contractWizardReducer';
import { ApiNotification, LogUser, Profile, ThemeCustomization } from './api';
import { ContentfulState } from '../redux/reducers/contentful/ContentfulState';

export type DispatchLogUser = ThunkDispatch<
	Promise<LogUser>,
	void,
	Action<string>
>;

export type DispatchFetchProfile = ThunkDispatch<
	Promise<Profile>,
	void,
	Action<string>
>;

export type DispatchApiNotification = ThunkDispatch<
	Promise<ApiNotification>,
	void,
	Action<string>
>;

export type DispatchThunkAny = ThunkDispatch<
	Promise<any>,
	void,
	Action<string>
>;
export interface NotificationState {
	code: string;
	message: string;
}
export interface UserState {
	name: string;
	email: string;
	company: string;
	access_token: string;
	refresh_token: string;
	status: string;
	profileStatus: string;
	salesType: SalesType[];
	switchedToBackoffice: boolean;
}
export enum SalesType {
	UNDEFINED = 'undefined',
	TEST = 'test',
	KPP = 'kpp', // Kaufpreis Monatliche-Zahlung
	KPE = 'kpe', // Kaufpreis Einmal-Zahlung
	KEH = 'keh', // Kaufpreis Händler-inkasso
	EPK = 'epk', // Kundenstrecke   (epm, eppm, epe, epp)
	EPH = 'eph', // Haendlerstrecke (eph, epph)
}
export enum Produkt {
	EP = 'EvoProtect',
	EPP = 'EvoProtect Premium',
}

const produktsToProduktLine = new Map();
produktsToProduktLine.set(SalesType.EPK,['epm', 'eppm', 'epe', 'epp']);
produktsToProduktLine.set(SalesType.EPH,['eph', 'epph']);
produktsToProduktLine.set(SalesType.KPP,['kpp']);
produktsToProduktLine.set(SalesType.KPE,['kpe']);
produktsToProduktLine.set(SalesType.KEH,['keh']);

export const mapProdukteToSalesType = (products: String [] | SalesType[]) => {
		const salesTypes = new Set();
		produktsToProduktLine.forEach((value, key)=> {
			products.forEach(p => {
				if (value.includes(p) ) {
					salesTypes.add(key);
				}
			})
		})
	return Array.from(salesTypes) as SalesType[];
}
export enum FahrzeugType {
	P = 'Pkw',
	W = 'Freizeit',
	M = 'Kraftrad'
}
export enum Zahlweise {
	MB = 'monatlich',
	EB = 'einmalig',
}
export interface Constalation {
	salesType: SalesType,
	produkt:  Produkt,
	zahlweise: Zahlweise,
	api: BackendProdukt

}
export enum BackendProdukt {
	epm = 'epm',
	eppm = 'eppm',
	epe = 'epe',
	eph = 'eph',
	epp = 'epp',
	epph = 'epph',
}

const epm:  Constalation = {salesType: SalesType.EPK, produkt: Produkt.EP,  zahlweise: Zahlweise.MB, api: BackendProdukt.epm};
const eppm: Constalation = {salesType: SalesType.EPK, produkt: Produkt.EPP ,zahlweise: Zahlweise.MB, api: BackendProdukt.eppm};
const epe:  Constalation = {salesType: SalesType.EPK, produkt: Produkt.EP,  zahlweise: Zahlweise.EB, api: BackendProdukt.epe};
const eph:  Constalation = {salesType: SalesType.EPH, produkt: Produkt.EP,  zahlweise: Zahlweise.EB, api: BackendProdukt.eph};
const epp:  Constalation = {salesType: SalesType.EPK, produkt: Produkt.EPP, zahlweise: Zahlweise.EB, api: BackendProdukt.epp};
const epph: Constalation = {salesType: SalesType.EPH, produkt: Produkt.EPP, zahlweise: Zahlweise.EB, api: BackendProdukt.epph};

const products:Constalation[] = [epm, eppm, epe, epp, eph, epph]
export const getProductPathFromContractConstalation = (cs: ContractState): BackendProdukt  => {
	const result:Constalation[] = products.filter(c=> cs.salesType===c.salesType && cs.produkt===c.produkt && cs.zahlweise===c.zahlweise)
	if (result.length !== 1)
		return BackendProdukt.epe;
	return result[0].api;
}


export enum CarState {
	NEW_CAR = 'newCar',
	USED_CAR = 'usedCar',
}
export interface ContractState {
	salesType: SalesType;
	produkt?: Produkt;
	prozessId: string;
	laufzeit?: number; // integer
	zahlweise?: Zahlweise; // hardcoded: "monatlich"
	kaufpreis: number; // float
	kaufdatum: string; // YYYY-MM-DD date
	zulassungsdatum: string; // YYYY-MM-DD date
	beginndatum: string; // YYYY-MM-DD date
	neufahrzeug?: boolean;
	fahrzeugtyp?: FahrzeugType; // P=PKW, W=Wohnmobil, M=Motorrad
	beitrag: number; // float
	ausweisId: string;
	ausweisType: string;
	vorname: string;
	name: string;
	email: string;
	kaufvertragsnummer: string;
	telefonnummer: string;
	geburtsdatum: string;
	street: string;
	streetNumber: string;
	strasse: string;
	plz: string;
	ort: string;
	launchUrl: string;
	iban: string;
	bic: string;
	bank: string;
	earliestRegistrationDate: string;
}
export interface ContractPricesState {
	24: number | null;
	36: number | null;
	48: number | null;
	60: number | null;
	mob: number | null;
	mwd: number | null;
}
export interface BankValidationState {
	IBAN: string;
	bankName: string;
	BIC: string;
	isValid: boolean | null;
}
export enum ContractSignatureStatus {
	WAITING,
	SIGNED,
	ABORTED,
	SIGN_LATER,
}
export interface ContractSignatureState {
	iframeUrl: string;
	status: ContractSignatureStatus;
}
export enum ContractFinishStatus {
	WAITING,
	FINISHED,
	ABORTED,
	FINISHED_LATER,
}
export interface ContractFinishState {
	status: ContractFinishStatus;
}
export enum CollectedSelection {
	FINISH_NOT_CHOSE,
	FINISH_BY_MAIL_LATER ,
	FINISH_BY_MAIL
}
export enum KehButton {
	NOT_SELECTED,
	FINISH_LATER,
	FINISH_NOW,
	CALC_NOW,
}
export interface CollectedState {
	status: CollectedSelection,
	selectedButton: KehButton,
}
export interface CustomizingState extends ThemeCustomization {
	status: string;
}
export interface AppState {
	collectedState: CollectedState;
	router: RouterState;
	user: UserState;
	contract: ContractState;
	contractWizard: ContractWizardState;
	contractPrices: ContractPricesState;
	bankValidation: BankValidationState;
	contractSignature: ContractFinishState;
	contractFinish: ContractFinishState;
	contentful: ContentfulState;
	notification: NotificationState;
	customizing: CustomizingState;
}

export interface AppStore {
	getState(): AppState;
	dispatch(action: any): any;
}
